module.exports = __webpack_public_path__ + "static/img/modelDataBookManage.bea55ff0.png";